import {Interest} from "../../../../domain/entities/entities";
import {InterfaceInterestUseCases} from "../../../../domain/usecase/impl/interestUseCases";
import {ActionContext} from "vuex";

class InterestState {
  interests: Interest[] = [];
}

const state = new InterestState();

const mutations = {
  SET_INTERESTS(state: InterestState, interests: Interest[]): void {
    state.interests = interests;
  },

  SET_INTERESTS_USER(state: InterestState, interests: Interest[]): void {
    state.interests = interests;
  },
};

const actions = {
  async loadInterests({ commit }: ActionContext<InterestState, InterestState>): Promise<void> {
    const interests = await InterfaceInterestUseCases.list();
    commit("SET_INTERESTS", interests);
  },

  async listUserInterest({ commit }: ActionContext<InterestState, InterestState>): Promise<void> {
    const interests = await InterfaceInterestUseCases.listUserInterest();
    commit("SET_INTERESTS_USER", interests);
  },

  async relateInterestToUser(_, interests: Interest[]): Promise<void> {
    await InterfaceInterestUseCases.relateInterestToUser(interests);
  },
};

const getters = {
  interests: (state: InterestState): Interest[] => state.interests || [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
